const JourneySection = () => {
  const milestones = [
    {
      year: '2018',
      title: 'Chess Beginnings',
      description: 'Started competitive chess journey, discovering a passion for strategic thinking and mental discipline.',
    },
    {
      year: '2022',
      title: 'VEX World Championship',
      description: 'Competed at VEX World Championship, igniting passion for robotics engineering and collaborative innovation.',
    },
    {
      year: '2023',
      title: 'National Master Title',
      description: 'Earned National Master title in chess, becoming one of the youngest achievers in the Philippines.',
    },
    {
      year: '2024',
      title: '3x National Champion',
      description: 'Won third National Chess Championship and led robotics team to national victories in both VEX and FRC.',
    },
    {
      year: '2025',
      title: 'Social Impact Leader',
      description: 'Expanded community outreach programs, teaching chess in prisons and raising funds for underprivileged students.',
    },
  ];

  return (
    <section className="py-16 sm:py-20 lg:py-24 px-4 sm:px-6 lg:px-8">
      <div className="container mx-auto max-w-6xl">
        <div className="text-center mb-8 sm:mb-12">
          <h2
            className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-heading font-bold mb-3 sm:mb-4"
            style={{ color: 'var(--color-heading)' }}
          >
            My Journey
          </h2>
          <p
            className="text-base sm:text-lg max-w-3xl mx-auto"
            style={{ color: 'var(--color-subtle)' }}
          >
            From discovering chess to leading robotics teams and creating social impact,
            every step has shaped who I am today.
          </p>
        </div>

        {/* Timeline */}
        <div className="relative">
          {/* Vertical line */}
          <div
            className="absolute left-8 top-0 bottom-0 w-0.5 hidden md:block"
            style={{ backgroundColor: 'var(--color-border-medium)' }}
          ></div>

          <div className="space-y-6 sm:space-y-8">
            {milestones.map((milestone, index) => (
              <div
                key={index}
                className="relative pl-0 md:pl-24"
              >
                {/* Year indicator */}
                <div className="absolute left-0 top-0 hidden md:block">
                  <div
                    className="w-14 h-14 md:w-16 md:h-16 rounded-full flex items-center justify-center font-bold text-base md:text-lg"
                    style={{
                      backgroundColor: 'var(--color-accent-6)',
                      color: 'white',
                      boxShadow: '0 0 0 4px var(--color-body-bg), 0 0 0 6px var(--color-accent-3)'
                    }}
                  >
                    {milestone.year.slice(2)}
                  </div>
                </div>

                {/* Content card */}
                <div
                  className="p-4 sm:p-6 rounded-lg transition-all duration-300 hover:shadow-card-hover"
                  style={{
                    backgroundColor: 'var(--color-card-bg)',
                    borderWidth: '1px',
                    borderStyle: 'solid',
                    borderColor: 'var(--color-card-border)',
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.borderColor = 'var(--color-card-hover-border)';
                    e.currentTarget.style.transform = 'translateY(-2px)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.borderColor = 'var(--color-card-border)';
                    e.currentTarget.style.transform = 'translateY(0)';
                  }}
                >
                  <div className="flex items-start gap-3 sm:gap-4">
                    <span
                      className="md:hidden text-xl sm:text-2xl font-bold shrink-0"
                      style={{ color: 'var(--color-accent-6)' }}
                    >
                      {milestone.year}
                    </span>
                    <div className="flex-1">
                      <h3
                        className="text-lg sm:text-xl font-bold mb-2"
                        style={{ color: 'var(--color-heading)' }}
                      >
                        {milestone.title}
                      </h3>
                      <p
                        className="text-sm sm:text-base leading-relaxed"
                        style={{ color: 'var(--color-subtle)' }}
                      >
                        {milestone.description}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default JourneySection;
